<script >
import config from "../config";

import { getQueryString,redirectToAuthLogin } from '@/utils/common'
import { storage } from '@/utils/storage'
import { cookie } from '@/utils/cookie'
import { getAdvInfo } from '@/api/admin'
import {getMyBooks,setBookTop, setBookShelf, setBookSorts, setBookDetermine, deleteMyBook } from '@/api/book'
import { refundNow, confirmIncome } from '@/api/pay'
export default {
  name:"",
  data() {
    return {
      ifFilter:false,
      svapid:'',
      param:{
        keyWords:'',//关键词
        types:'',//（空=全部料:1：返还料、0：普通料）
        pageNum:1,//当前页
      },
      articleList:[],
      loading:false,
      finished:false,
      // 当前操作的作品
      currentBook:null,
      // 权重弹窗
      sortPopupVisible:false,
      sortValue:'',
      // 标签弹窗
      tagPopupVisible:false,
      tagValue:0,
      deletingBookId:'',
      tagOptions: [
        { value: 0, label: '重置（不加标签）' },
        { value: 1, label: '红' },
        { value: 2, label: '黑' },
        { value: 3, label: '走' },
        { value: 21, label: '2中1' },
        { value: 32, label: '3中2' },
        { value: 43, label: '4中3' },
        { value: 66, label: '被绝杀' }
      ],
    }
  },
    mounted() {
      const svapid = getQueryString('svapid') ||  (config && config.svapid)
      const token = getQueryString('token') || storage.get('token')
      this.init(svapid,token)
      window.addEventListener('scroll', this.onWindowScroll, { passive: true })
    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.onWindowScroll)
    },
  methods: {
    async init(svapid,token){
      this.svapid = svapid
      storage.set("svapid",svapid)
      if (this.svapid) {
        await this.fetchAndCacheAdvInfo(svapid)
        if (token && token != 'undefined'){
          storage.set("token",token)
          await this.refreshList()
        }else {
          // 未登录：跳转登录页（带上回跳地址）
          redirectToAuthLogin({ svapid: this.svapid,appid:storage.get("appid") })
        }
      }

    },
    async refreshList() {
      this.param.pageNum = 1
      this.articleList = []
      this.finished = false
      await this.loadMore()
    },
    async loadMore() {
      if (this.loading || this.finished) return
      this.loading = true
      try {
        const res = await getMyBooks({
          types: this.param.types === '' ? undefined : this.param.types,
          pageNum: this.param.pageNum,
          keyWords: (this.param.keyWords || '').trim() || undefined
        })
        const data = (res && (res.data || res.rows || res.list)) || res
        const page = (res && res.data) ? res.data : res
        const rows = (page && page.rows) ? page.rows : (Array.isArray(data) ? data : [])
        if (this.param.pageNum === 1) {
          this.articleList = rows || []
        } else {
          this.articleList = this.articleList.concat(rows || [])
        }
        const total = page && typeof page.total === 'number' ? page.total : null
        if (!rows || rows.length === 0) {
          this.finished = true
        } else if (total != null && this.articleList.length >= total) {
          this.finished = true
        } else {
          this.param.pageNum += 1
        }
      } catch (e) {
        // ignore
      } finally {
        this.loading = false
      }
    },
    onWindowScroll() {
      if (this.loading || this.finished) return
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      const windowHeight = window.innerHeight || document.documentElement.clientHeight || 0
      const fullHeight = document.documentElement.scrollHeight || document.body.scrollHeight || 0
      if (scrollTop + windowHeight + 120 >= fullHeight) {
        this.loadMore()
      }
    },
    onSearch() {
      this.refreshList()
    },
    pickType(t) {
      // ''=全部 1=返还料 0=普通料
      this.param.types = t
      this.ifFilter = false
      this.refreshList()
    },
    async toggleTop(item) {
      if (!item || !item.id) return
      const next = item.zhiding ? 0 : 1
      await setBookTop({ id: item.id, flag: next })
      await this.refreshList()
    },
    async toggleShelf(item) {
      if (!item || !item.id) return
      // status: 1=下架 0=上架；接口 flag: 1=下架 0=上架
      const next = Number(item.status || 0) === 1 ? 0 : 1
      await setBookShelf({ id: item.id, flag: next })
      await this.refreshList()
    },
    openSortPopup(item) {
      this.currentBook = item
      this.sortValue = item && item.sorts != null ? String(item.sorts) : ''
      this.sortPopupVisible = true
    },
    closeSortPopup() {
      this.sortPopupVisible = false
      this.currentBook = null
      this.sortValue = ''
    },
    async confirmSortPopup() {
      const item = this.currentBook
      const v = Number(this.sortValue)
      if (!item || !item.id) return this.closeSortPopup()
      if (!Number.isFinite(v) || v < 0 || v > 999) return
      await setBookSorts({ id: item.id, value: v })
      item.sorts = v
      this.closeSortPopup()
      await this.refreshList()
    },
    openTagPopup(item) {
      this.currentBook = item
      this.tagValue = item && item.determine != null ? Number(item.determine) : 0
      this.tagPopupVisible = true
    },
    closeTagPopup() {
      this.tagPopupVisible = false
      this.currentBook = null
    },
    async confirmTagPopup() {
      const item = this.currentBook
      if (!item || !item.id) return this.closeTagPopup()
      await setBookDetermine({ id: item.id, value: Number(this.tagValue || 0) })
      item.determine = Number(this.tagValue || 0)
      this.closeTagPopup()
      await this.refreshList()
    },
    onDeleteBook(item) {
      if (!item || !item.id) return
      if (!this.$createDialog) {
        this.confirmDeleteBook(item)
        return
      }
      this.$createDialog({
        type: 'confirm',
        title: '提示',
        content: '确认删除该资料？',
        onConfirm: () => this.confirmDeleteBook(item),
        onCancel: () => {}
      }).show()
    },
    async confirmDeleteBook(item) {
      if (!item || !item.id || this.deletingBookId) return
      this.deletingBookId = String(item.id)
      const loading = this.$createToast ? this.$createToast({ type: 'loading', time: 0, txt: '删除中...' }) : null
      loading && loading.show()
      try {
        await deleteMyBook({ id: String(item.id) })
        this.$createToast && this.$createToast({ type: 'correct', time: 800, txt: '删除成功' }).show()
        await this.refreshList()
      } catch (e) {
        this.$createToast && this.$createToast({ type: 'warn', time: 1000, txt: '删除失败' }).show()
      } finally {
        loading && loading.hide()
        this.deletingBookId = ''
      }
    },
    onRefundNow(item) {
      if (!item || !item.id) return
      if (item.types !== 1 && item.types !== '1') return
      const run = () => this.confirmRefundNow(item)
      if (!this.$createDialog) return run()
      this.$createDialog({
        type: 'confirm',
        title: '提示',
        content: '确认对该返还料执行立即退款？',
        onConfirm: run,
        onCancel: () => {}
      }).show()
    },
    async confirmRefundNow(item) {
      const loading = this.$createToast ? this.$createToast({ type: 'loading', time: 0, txt: '退款处理中...' }) : null
      loading && loading.show()
      try {
        const res = await refundNow({ bookId: String(item.id) })
        const msg = (res && (res.msg || res.message)) || '操作成功'
        this.$createToast && this.$createToast({ type: 'correct', time: 1200, txt: msg }).show()
        await this.refreshList()
      } catch (e) {
        this.$createToast && this.$createToast({ type: 'warn', time: 1200, txt: '退款失败' }).show()
      } finally {
        loading && loading.hide()
      }
    },
    onConfirmIncome(item) {
      if (!item || !item.id) return
      if (item.types !== 1 && item.types !== '1') return
      const run = () => this.confirmIncomeAction(item)
      if (!this.$createDialog) return run()
      this.$createDialog({
        type: 'confirm',
        title: '提示',
        content: '确认该返还料为正确收款并正式入账？',
        onConfirm: run,
        onCancel: () => {}
      }).show()
    },
    async confirmIncomeAction(item) {
      const loading = this.$createToast ? this.$createToast({ type: 'loading', time: 0, txt: '入账处理中...' }) : null
      loading && loading.show()
      try {
        const res = await confirmIncome({ bookId: String(item.id) })
        const msg = (res && (res.msg || res.message)) || '操作成功'
        this.$createToast && this.$createToast({ type: 'correct', time: 1200, txt: msg }).show()
        await this.refreshList()
      } catch (e) {
        this.$createToast && this.$createToast({ type: 'warn', time: 1200, txt: '操作失败' }).show()
      } finally {
        loading && loading.hide()
      }
    },
    async fetchAndCacheAdvInfo (svapid) {
      try {
        const res = await getAdvInfo({ svapid })
        const adv = (res && res.data) ? res.data : (res || {})
        cookie.set('svapid', svapid, { days: 31, path: '/' })
        cookie.set('advance', JSON.stringify(adv || {}), { days: 31, path: '/' })
        storage.set('appid', adv.appid)
      } catch (e) {
        // ignore cache errors
        // ignore cache errors
      }
    },
    // redirectToAuthLogin({ svapid,appid } = {}) {
    //   const redirectUrl = this.buildMainLiaoUrl(svapid)
    //   try {
    //     const loginUrl =
    //       config.loginUrl +
    //       '?redirectUrl=' +
    //       encodeURIComponent(redirectUrl) +
    //       '&svapid=' +
    //       encodeURIComponent(svapid || '') +
    //       '&appid=' +
    //       encodeURIComponent(appid || '')
    //     window.location.replace(loginUrl)
    //     return
    //   } catch (e) {
    //     // fallthrough
    //   }
    //
    //
    // },
    // buildMainLiaoUrl(svapid) {
    //   return window.location.origin +'/mainLiao?svapid=' + encodeURIComponent(svapid || '') + '&time=' + encodeURIComponent( Date.now().toString())
    // }
  }
}
</script>

<template>
      <div class="xinliao-wrapper">
        <div class="xinliao-content">
          <div class="tabs">
            <span class="tab active">我的文章</span>
            <span class="tab">会员专辑(包月包时)</span></div>
          <div class="list-wrapper">
            <div class="l_search">
              <div class="l_s_filter" @click="ifFilter =!ifFilter">全部料
                <i class="cubeic-select"></i></div>
              <div class="l_s_search">
                <div>
                  <div class="searchBar">
                    <div style="width: 100%;">
                      <cube-input v-model="param.keyWords"  placeholder="输入标题搜索"  class="searchbook"></cube-input>
                    </div>
                    <div class="searchBtn" @click="onSearch">
                      <span class="cubeic-search"></span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="searchBtn" @click="onSearch"></div>
              <div class="l_filter" v-if="ifFilter">
                <div class="content">
                  <div class="selected">
                    <div class="item" :class="{ active: param.types === '' }" @click="pickType('')">全部料</div>
                    <div class="item" :class="{ active: param.types === 1 || param.types === '1' }" @click="pickType(1)">返还料</div>
                    <div class="item" :class="{ active: param.types === 0 || param.types === '0' }" @click="pickType(0)">普通料</div></div>
                </div>
              </div>
            </div>
            <div class="l_content">
              <div class="cube-scroll-wrapper scroll-list">
                <div class="cube-scroll-content" style="transition-timing-function: cubic-bezier(0.165, 0.84, 0.44, 1); transition-duration: 0ms; transform: translate(0px, 0px) scale(1) translateZ(0px);">
                  <div class="cube-scroll-list-wrapper" style="min-height: 616px;">
                  <div class="article">
                      <div v-for="item in articleList" :key="item.id">
                        <div class="publish-item">
                          <div class="publishStatus">
<!--                            红-->
                            <img  src="http://oss.xuekastart.cn/jinriyouliao/status1.png" class="icon" v-if="item.determine==1">
<!--                            黑-->
                            <img  src="http://oss.xuekastart.cn/jinriyouliao/status2.png" class="icon" v-if="item.determine==2">
<!--                            2中1-->
                            <img  src="http://oss.xuekastart.cn/jinriyouliao/status21.png" class="icon" v-if="item.determine==3">
<!--                            走-->
                            <img  src="http://oss.xuekastart.cn/jinriyouliao/status3.png" class="icon" v-if="item.determine==4">
<!--                            3中2-->
                            <img  src="http://oss.xuekastart.cn/jinriyouliao/status32.png" class="icon" v-if="item.determine==5">
<!--                            4中3-->
                            <img  src="http://oss.xuekastart.cn/jinriyouliao//status43.png" class="icon" v-if="item.determine==6">
<!--                            被绝杀-->
                            <img  src="http://oss.xuekastart.cn/jinriyouliao/status66.png" class="icon" v-if="item.determine==7">
                          </div>
                          <img v-if="item.isopen" src="http://oss.xuekastart.cn/jinriyouliao/gongkai.png" alt="" class="sellStatus gonkai">
                          <!---->
                          <img v-if="Number(item.status || 0) === 0" src="http://oss.xuekastart.cn/jinriyouliao/zaishou.png" alt="" class="sellStatus">
                          <img v-else src="http://oss.xuekastart.cn/jinriyouliao/xiajia.png" alt="" class="sellStatus">
                          <!---->
                          <div class="item-time" @click="goUrl('/datacode?proid=' + item.id)">
                            <div style="display: flex; align-items: center;">
                              <time>发布于{{ item.createTime || '' }}</time>
                              <div class="i_sort">
                                <div class="i_s_btn" @click="openSortPopup(item)">排序</div>
                                <!----></div>
                            </div>
                            <img v-if="item.types === 1 || item.types === '1'"  src="https://oss.zhishijingling.com/jinriyouliao/list/bufanhuan.png" class="bufanhuan">
                            </div>
                          <div class="p_title" @click="goUrl('/datacode?proid=' + item.id)">
                            <!---->
                            <div class="p_t_name" >
                              <div>
                                <!---->
                                <span>{{ item.bookName }}</span>
                                <div style="display: inline-block;"></div>
                              </div>
                              <div class="p_tdesc"><div>{{ item.subName }}</div></div>
                            </div>
                            <div class="p_t_price">{{ Number(item.price || 0) === 0 ? '免费' : ('￥' + item.price) }}</div></div>
                          <div class="p_footer" @click="goUrl('/datacode?proid=' + item.id)">
                            <div class="p_f_item">
                              <div class="p_f_i_name">查看人数</div>
                              <div class="p_f_i_num">{{ item.scanNum || 0 }}</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">已售/已返还</div>
                              <div class="p_f_i_num">{{ item.soldNum || 0 }}</div></div>
                            <div class="p_f_item">
                              <div class="p_f_i_name">收益总额/元</div>
                              <div class="p_f_i_num colorRed">{{ item.totalProfit || 0 }}</div></div>
                          </div>
                          <div class="options">
                            <div class="oBtn" :class="{ active: item.zhiding }" @click="toggleTop(item)">{{ item.zhiding ? '取消置顶' : '置顶' }}</div>
                            <div class="oBtnShortSj" @click="toggleShelf(item)">{{ Number(item.status || 0) === 1 ? '上 架' : '下 架' }}</div>
                            <!---->
                            <div class="oBtnShort" @click="openTagPopup(item)">加标签</div>
                            <div class="oBtn" v-if="item.types==1" @click="onRefundNow(item)">立即退款</div>
                            <div class="oBtn bgRed" v-if="item.types==1" @click="onConfirmIncome(item)">正确收款</div>
                            <img src="http://oss.xuekastart.cn/jinriyouliao/delete.png" alt="" class="oDelete" @click="onDeleteBook(item)">
                          </div>
                      </div>
                    </div>
                    <div index="0" style="display: none">
                      <div class="content">
                        <!---->
                        <img src="https://oss.zhishijingling.com/jinriyouliao/list/xiajia.png" alt="" class="sellStatus">
                        <div class="c_time">发布于05-13 19:59:56
                          <!----></div>
                        <div class="c_header">
                          <div class="c_content">
                            <div class="c_h_left">
                              <img src="http://oss.zhishijingling.com/haoliaodata/2024-05-13/049f04e648ee4be0824fd1471c7fb7471715601534550_605.jpg"></div>
                            <div class="c_h_right">
                              <div class="c_h_r_title">牛彩转去
                                <span class="tag month">包月</span></div>
                              <div class="c_h_r_total">共0篇文章</div></div>
                          </div>
                          <div class="c_h_right">
                            <img src="https://oss.zhishijingling.com/jinriyouliao/right.png"></div>
                        </div>
                        <div class="total">
                          <div class="t_item">
                            <div class="t_i_title">累计查看(人)</div>
                            <div class="t_i_number">0</div></div>
                          <div class="t_item">
                            <div class="t_i_title">累计购买(人)</div>
                            <div class="t_i_number">0</div></div>
                          <div class="t_item">
                            <div class="t_i_title">累计收款(元)</div>
                            <div class="t_i_number" style="color: rgb(247, 73, 5);">0</div></div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="cube-pullup-wrapper">
                    <div class="before-trigger">
                      <span v-if="loading">加载中...</span>
                      <span v-else-if="finished">没有更多了</span>
                      <span v-else></span>
                    </div>
                  </div>
                  <div class="cube-pullup-wrapper">
                    <div class="before-trigger">
                      <span></span>
                    </div>
                  </div>
                </div>
                </div>
            </div>


          </div>
        </div>
        <div>
          <bottom-tab-bar />
        </div>
        <!-- 设置权限大小弹出窗-->
        <div v-if="sortPopupVisible" class="cube-popup cube-popup_mask cube-dialog" style="z-index: 100;">
          <div class="cube-popup-mask" @click="closeSortPopup"></div>
          <div class="cube-popup-container cube-popup-center">
            <div class="cube-popup-content">
              <div class="cube-dialog-main">
        <span class="cube-dialog-close" style="display: none;">
          <i class="cubeic-close"></i>
        </span>
                <div class="cube-dialog-prompt">
                  <!---->
                  <h2 class="cube-dialog-title">
                    <p class="cube-dialog-title-def">提示</p></h2>
                  <div class="cube-dialog-content">
                    <div class="cube-dialog-content-def">
                      <p>权数越大，排序越高，最大999</p>
                      <div class="cube-input">
                        <!---->
                        <input v-model="sortValue" type="text" placeholder="请输入权数" maxlength="3" class="cube-input-field">
                        <!----></div>
                    </div>
                  </div>
                  <div class="cube-dialog-btns border-right-1px">
                    <a href="javascript:;" class="cube-dialog-btn border-top-1px" @click="closeSortPopup">取消</a>
                    <a href="javascript:;" class="cube-dialog-btn border-top-1px cube-dialog-btn_highlight" @click="confirmSortPopup">确定</a></div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!--加标签弹出窗-->
        <div v-if="tagPopupVisible" class="cube-popup cube-popup_mask cube-picker" style="z-index: 100;">
          <div class="cube-popup-mask" @click="closeTagPopup"></div>
          <div class="cube-popup-container">
            <div class="cube-popup-content">
              <div class="cube-picker-panel cube-safe-area-pb">
                <div class="cube-picker-choose border-bottom-1px">
                  <span class="cube-picker-cancel" @click="closeTagPopup">取消</span>
                  <span class="cube-picker-confirm" @click="confirmTagPopup">确定</span>
                  <div class="cube-picker-title-group">
                    <h1 class="cube-picker-title">加标签</h1></div>
                </div>
                <div>
                  <div class="content">
                    <div class="cube-radio-group border-top-1px border-bottom-1px" data-v-1c6381ca="">
                      <div
                        v-for="opt in tagOptions"
                        :key="opt.value"
                        data-pos="right"
                        class="cube-radio cube-radio-hollow"
                        :class="{ 'cube-radio_selected': Number(tagValue) === Number(opt.value) }"
                        @click="tagValue = opt.value"
                      >
                        <label class="cube-radio-wrap border-bottom-1px">
                          <input type="radio" class="cube-radio-input" :value="String(opt.value)">
                          <span class="cube-radio-ui cubeic-round-border">
                            <i></i>
                          </span>
                          <span class="cube-radio-label">{{ opt.label }}</span>
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      </div>
</template>

<style>

</style>



// WEBPACK FOOTER //
// src/components/mainLiao.vue